<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  formatSalesTableDate,
  salesCorrectionGroups,
  salesElapsedClass,
  salesElapsedDays,
} from './salesTransactionListCells';

const props = defineProps({
  transaction: { type: Object, required: true },
});

const { t } = useI18n();
const profile = computed(() => props.transaction.profile || {});
const review = computed(() => props.transaction.review || {});
const postSale = computed(() => props.transaction.post_sale || {});
const emptyValue = computed(() => t('SALES.TABLE.EMPTY_VALUE'));
const signatureDate = computed(() => profile.value.data_assinatura);
const requestDate = computed(() => review.value.submitted_at);
const elapsedDays = computed(() => salesElapsedDays(signatureDate.value));
const elapsedClass = computed(() => salesElapsedClass(elapsedDays.value));
const correctionGroups = computed(() => salesCorrectionGroups(review.value, t));
const formatDate = value => formatSalesTableDate(value, emptyValue.value);
</script>

<template>
  <td class="whitespace-nowrap p-4 text-lais-text-body">
    {{ formatDate(signatureDate) }}
  </td>
  <td class="p-4 text-lais-text-body">
    <p>{{ formatDate(requestDate) }}</p>
    <span class="text-xs text-lais-text-muted">
      {{ postSale.responsible?.name || emptyValue }}
    </span>
  </td>
  <td class="p-4 text-center text-lg font-semibold" :class="elapsedClass">
    {{ elapsedDays ?? emptyValue }}
  </td>
  <td class="p-4">
    <div
      class="flex flex-wrap gap-2"
      :aria-label="t('SALES.TABLE.CORRECTIONS')"
    >
      <span
        v-for="group in correctionGroups"
        :key="group.key"
        class="inline-flex items-center gap-1 rounded-full bg-lais-bg-soft px-2 py-1 text-xs"
        :title="group.label"
      >
        <span :class="group.icon" aria-hidden="true" />
        <span class="sr-only">{{ group.label }}</span>
      </span>
    </div>
  </td>
</template>
